<style lang="scss" scoped>
.mobile-search {
    position: relative;
    width: 64px;
    height: 64px;

    .search-icon {
        content: url("/svg/search-dark.svg");
        width: 20px;
        height: 18px;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.15s;

        &.active {
            content: url("/svg/close.svg") !important;
            color: #fff !important;
        }
    }
}
</style>

<template>
    <div class="mobile-search d-md-none">
        <div class="search-icon" :class="{'active': isActive}" @click="toggleMobileSearch"></div>
    </div>
</template>

<script>
export default {
    name: "elements.mobile-search",

    methods: {
        toggleMobileSearch() {
            this.$root.navigationIsVisble = false;
            this.$root.mobileSearchIsVisible = !this.$root.mobileSearchIsVisible;
        }
    },

    computed: {
        isActive() {
            return this.$root.mobileSearchIsVisible;
        }
    }
}
</script>